import React, { useEffect, useState } from 'react';

const multiItemQuestionnaireWithLocalStorage = (WrappedComponent, defaultItem, localStorageName) => {
    const MultiItemComponent = props => {
        const [array, setArray] = useState([]);

        useEffect(() => {
            const localStorageData = localStorage.getItem(localStorageName) && JSON.parse(localStorage.getItem(localStorageName));
            const propsData = props.profile && props.profile[localStorageName];
            const storedData = localStorageData || propsData;

            if (storedData) setArray(storedData);
        }, [props.profile]);

        const handleAddItemStateArray = async e => {
            let newArray = [...array, { ...defaultItem }];
            setArray(newArray);
            localStorage.setItem(localStorageName, JSON.stringify(newArray));
        };
        const handleRemoveItemStateArray = removeIndex => e => {
            let remainingData = [...array];
            remainingData.splice(removeIndex, 1);
            setArray(remainingData);
            localStorage.setItem(localStorageName, JSON.stringify(remainingData));
        };
        const handleStateArrayItemChange = (index, field) => e => {
            let modifiedData = array.map(
                (data, i) => {
                    if (i === index) data[field] = e.target.value;
                    return data;
                }
            );
            setArray(modifiedData);
            localStorage.setItem(localStorageName, JSON.stringify(modifiedData));
        };

        return <WrappedComponent
            onAdd={handleAddItemStateArray}
            onRemove={handleRemoveItemStateArray}
            onChange={handleStateArrayItemChange}
            items={array}
            {...props}
        />

    };

    return MultiItemComponent;
};

export default multiItemQuestionnaireWithLocalStorage;